export const InvestmentFilterElements = {
	investmentFiltersId: 'investmentFiltersId',
	investmentOptionsFilterId: 'investmentOptionsFilterId',
	allInvestmentCheckboxFilterId: 'allInvestmentCheckboxFilterId',
	superInvestmentCheckboxFilterId: 'superInvestmentCheckboxFilterId',
	investmentInvestmentCheckboxFilterId: 'investmentInvestmentCheckboxFilterId',
	retirementInvestmentCheckboxFilterId: 'retirementInvestmentCheckboxFilterId',
	businessSuperInvestmentCheckboxFilterId:
		'businessSuperInvestmentCheckboxFilterId',
	investmentBondsInvestmentCheckboxFilterId:
		'investmentBondsInvestmentCheckboxFilterId',
	minAdvisedPortfolioFilterId: 'minAdvisedPortfolioFilterId',
	maxAdvisedPortfolioFilterId: 'maxAdvisedPortfolioFilterId',
	advisedPortfolioErrorId: 'advisedPortfolioErrorId',
};
